
import { DatePipe } from '@angular/common';
import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { AppointmentService } from '../appointment.service';
import { LanguageService } from 'app/shared/language.service';
import { TranslateService } from '@ngx-translate/core';
export interface DialogData {
  Slottime: number;
  Appid: number;
  Doctorid: number;
  AppointmentNewdate: any;
  onGrid: boolean;
}
@Component({
  selector: 'app-transfer-appointment',
  templateUrl: './transfer-appointment.component.html',
  styleUrls: ['./transfer-appointment.component.scss']
})
export class TransferAppointmentComponent implements OnInit {
  @ViewChild('selectTimeSlot', { read: ElementRef }) selectTimeSlot: ElementRef;
  //todaydate= this.authService.getServerDate;
  // public selectedDate = this.datePipe.transform(this.todaydate, "yyyy-MM-dd");
  selectedDate: any;
  selecttime: any;
  schedulename: any;
  groupArrschedule = [];
  docotrid: any;
  mindate: any
  checkCurrentLesson1 = false;
  onGridreschedle: boolean;
  reselectTime: string = '';
  public selected = -1;
  branchid:any =0
  doctorlist:any=[];
  showspinner:boolean=false;
  constructor( public dialogRef: MatDialogRef<TransferAppointmentComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData, public authService: AuthService, public translate: TranslateService,
    public langservice: LanguageService,
    public appservice: AppointmentService, public opdvisitService: OpdVisitService, public dashboardService: DashboardService, private datePipe: DatePipe, public dialog: MatDialog,) {
    translate.addLangs(['en', 'fr', 'hi']);

    if (this.langservice.setlang) {
      translate.setDefaultLang(this.langservice.setlang);
    }
    else {
      translate.setDefaultLang('en');
    }
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.branchid =this.authService.Loggeduser.branchid;
    this.onGridreschedle = this.data.onGrid;
    this.mindate = this.authService.getServerDate;
    this.docotrid = this.data.Doctorid;
    
    // this.selecttime = `${new Date().getHours()}:${(new Date().getMinutes()<10?'0':'') + new Date().getMinutes()}`;
    this.selecttime = this.data.Slottime;
    this.selectedDate = this.data.AppointmentNewdate;
    this.schedulename = this.appservice.Doctor_time_info_Mod[0].scheduleType;
   
   
    if(this.data['DoctorType']){
      this.getDoctorBrach(this.data['DoctorType'], this.branchid);
    }
    
  }
  filterbydate() {
    if(this.data['DoctorType']){
      this.getDoctorBrach(this.data['DoctorType'], this.branchid);
    }
  }
  getDoctorBrach(doctortype :any,branchid:any) {
    this.showspinner=true;
    let sdate = this.datePipe.transform(this.selectedDate, "yyyy-MM-dd");
    this.appservice.app_doctors(doctortype, branchid,sdate).subscribe(
     (data) =>{
      if (this.authService.masterdata.isExternal === true) {
        this.doctorlist = data.filter(
          (item) => item.isExternal == false
        );
        this.docotrid =this.doctorlist[0]?.userId;
      } else {
        this.doctorlist = data;
        this.docotrid =this.doctorlist[0]?.userId;
     }
     this.changedoctorscedule();
     },err=>{
      this.showspinner=false;
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
     })
   
 }
  changedoctorscedule() {
    let sdate = this.datePipe.transform(this.selectedDate, "yyyy-MM-dd");
    this.showspinner=true;
    this.appservice.get_Transfer_Doctor(this.docotrid, sdate).subscribe(data => this.success_scheulde(data), err => this.failtupdate(err));

  }
  groupArr: any;
  success_scheulde(data) {
    this.showspinner=false;
    this.schedulename = "";
    this.groupArr = [];
    if (data.length > 0) {
      this.groupArr = data.reduce((r, { scheduleType }) => {
        if (!r.some(o => o.scheduleType == scheduleType)) {
          r.push({ scheduleType, groupItem: data.filter(v => v.scheduleType == scheduleType) });
        }
        return r;
      }, []);
      this.groupArrschedule = data;
      this.schedulename = this.groupArr[0].scheduleType;
      this.changescedule();
    } else {
      this.groupArr = [];
      this.filtertimebyschedule = [];
      this.checkCurrentLesson1 = false;
    }

  }
  failtupdate(err) {
    this.showspinner=false;
    this.filtertimebyschedule = [];
    this.checkCurrentLesson1 = false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  filtertimebyschedule = [];
  changescedule() {
    this.selected = -1;
    if (this.groupArrschedule.length > 0) {
      this.checkCurrentLesson1 = true;
      this.filtertimebyschedule = [];
      // for (var var1 of this.groupArr) {
      this.filtertimebyschedule = this.groupArrschedule.filter(item => item.scheduleType == this.schedulename);
      // }


    } else {
      this.checkCurrentLesson1 = false;
    }

  }
  closedialog() {

    this.dialogRef.close(0);
  }
  updateAppoint() {
debugger
    const currrentdate = this.authService.getServerDate;
    const currentimte = this.authService.localDate;
    if (Date.parse(this.datePipe.transform(currrentdate, "yyyy-MM-dd").toString()) == Date.parse(this.datePipe.transform(this.selectedDate, "yyyy-MM-dd").toString())) {
      let xHr = currentimte.getHours();//
      let xMin = currentimte.getMinutes();//
      this.selecttime = this.reselectTime != '' ? this.reselectTime : this.selectTimeSlot.nativeElement.value;
      let yTime = this.convertTo24Hour(this.selecttime);
      let ApptX = yTime.split(":");

      let RealTime = (xHr * 60) + xMin;
      let ApptTime = (parseInt(ApptX[0]) * 60) + parseInt(ApptX[1]);

      if (ApptTime < RealTime) {
        this.dashboardService.openSnackBar("Back time is Not Allowed", "Ok");

      } else {
        let appid = this.data.Appid
        let sdate = this.datePipe.transform(this.selectedDate, "yyyy-MM-dd");
        this.selecttime = this.reselectTime != '' ? this.reselectTime : this.selectTimeSlot.nativeElement.value;
        let stime = this.opdvisitService.convertTo24Hour(this.selecttime);
        this.appservice.DoctorId = this.docotrid;
        this.dashboardService.selectedRowIndex = this.docotrid;
        let scid = this.groupArrschedule.filter(item => item.scheduleType == this.schedulename);
        this.appservice.getAppointmentUpdte(appid, sdate, stime, this.appservice.DoctorId, scid[0].scheduleTypeId, this.authService.Loggeduser.branchid).subscribe(data => this.success_updateAppt(data), err => this.failed_apptupdate(err));
      }

    } else {
      let appid = this.data.Appid
      let sdate = this.datePipe.transform(this.selectedDate, "yyyy-MM-dd");
      this.selecttime = this.reselectTime != '' ? this.reselectTime : this.selectTimeSlot.nativeElement.value;
      let stime = this.opdvisitService.convertTo24Hour(this.selecttime);
      this.appservice.DoctorId = this.docotrid;
      this.dashboardService.selectedRowIndex = this.docotrid;
      let scid = this.groupArrschedule.filter(item => item.scheduleType == this.schedulename);
      this.appservice.getAppointmentUpdte(appid, sdate, stime, this.appservice.DoctorId, scid[0].scheduleTypeId, this.authService.Loggeduser.branchid).subscribe(data => this.success_updateAppt(data), err => this.failed_apptupdate(err));
    }

  }
  success_updateAppt(data) {

    this.opdvisitService.apptdetail.pkAppointmentId = data;
    this.dashboardService.openSnackBar("Appointment Transferred Successfully", "Ok");
   // this.appservice.showRec(this.authService.Loggeduser.branchid);
    this.dialogRef.close(1);
    // if (data.contactNo != "" && data.contactNo != null && data.contactNo != undefined) {
    //   var result = this.opdvisitService.doctors.filter(x => x.userId === data.fkConsultantId);
    //   this.opdvisitService.datasendsms.PatientName = data.firstName + ' ' + data.lastName;
    //   this.opdvisitService.datasendsms.MobileNo = data.contactNo;
    //   this.opdvisitService.datasendsms.MrdNo = null;
    //   this.opdvisitService.datasendsms.SeqNo = null;
    //   this.opdvisitService.datasendsms.ApptDate = data.apptDate;
    //   this.opdvisitService.datasendsms.ApptTime = data.apptTime;
    //   this.opdvisitService.datasendsms.ApptConsultant = result[0].userName;
    //   this.opdvisitService.datasendsms.SurgeryDate = null;
    //   this.opdvisitService.datasendsms.SurgeryTime = null;
    //   this.opdvisitService.datasendsms.BranchId = data.fkBranchId
    //   this.opdvisitService.datasendsms.SMSType = "APPTRESCHEDULE";
    //   this.opdvisitService.sendSMstoPatient(this.opdvisitService.datasendsms);
    // }
  }
  failed_apptupdate(err) {
    this.dashboardService.openSnackBar("Appointment Slot Not Available", "Ok");
  }
  chkSlot: number = 0;
  timevalidation: boolean = true;
  backtimeblock: boolean = true;
  colorBlock(event) {
    this.backtimeblock = true;
    this.timevalidation = true;
    const currrentdate = this.authService.getServerDate;
    const gettime = this.authService.localDate;
    var xHr = gettime.getHours();//
    var xMin = gettime.getMinutes();//
    var yTime = this.convertTo24Hour(event.time);
    if (Date.parse(this.datePipe.transform(currrentdate, "yyyy-MM-dd").toString()) == Date.parse(this.datePipe.transform(this.selectedDate, "yyyy-MM-dd").toString())) {
      let ApptX = yTime.split(":");

      let RealTime = (xHr * 60) + xMin;
      let ApptTime = (parseInt(ApptX[0]) * 60) + parseInt(ApptX[1]);

      if (ApptTime < RealTime) {
        this.backtimeblock = false;

      }
      if (event.isBlock == true) {
        return "#998b8b";
      } else if (event.isCancelled == true) {
        return "#f18686";
      } else if (event.isConfirm == true) {
        return "#CAF6B8";
      } else if (event.isConfirm == false && event.isConfirm != null) {
        this.chkSlot = 0;
        if (this.filtertimebyschedule.length > 0) {
          for (var val of this.filtertimebyschedule) {

            if (val.time == event.time && val.isCancelled == false && event.isConfirm != null) {

              this.chkSlot = this.chkSlot + 1;
              if (event.slotLimit == this.chkSlot) {
                this.chkSlot = 0;
                this.timevalidation = false;
              }
            }
          }
        }
        return "#b7c3d9";
      }
    } else {
      if (event.isBlock == true) {
        return "#998b8b";
      } else if (event.isCancelled == true) {
        return "#f18686";
      } else if (event.isConfirm == true) {
        return "#CAF6B8";
      } else if (event.isConfirm == false && event.isConfirm != null) {
        this.chkSlot = 0;
        if (this.filtertimebyschedule.length > 0) {
          for (var val of this.filtertimebyschedule) {

            if (val.time == event.time && val.isCancelled == false && event.isConfirm != null) {

              this.chkSlot = this.chkSlot + 1;
              if (event.slotLimit == this.chkSlot) {
                this.chkSlot = 0;
                this.timevalidation = false;
              }
            }
          }
        }
        return "#b7c3d9";
      }
    }




  }
  convertTo24Hour(time) {
    var hours = parseInt(time.substr(0, 2));
    if (time.indexOf('AM') != -1 && hours == 12) {
      time = time.replace('12', '0');
    }
    if (time.indexOf('PM') != -1 && hours < 12) {
      time = time.replace(hours, (hours + 12));
    }
    return time.replace(/(AM|PM)/, '');
  }

  selectedTime(item, i) {
    this.selected = i;
    this.reselectTime = item.time;
  }
}
